import { Pipe, PipeTransform, Injectable } from '@angular/core';


/**]
 * @author Nishitha Salver ( Oct 3rd, 2018)
 * @desc: to be used in accounting scenarios where negative balances are to be formatted for view.
 * Usage: <div *ngIf="rowData.ytdBalance">{{rowData.ytdBalance |currency:Format.Currency | negativeCurrency}}</div>
 * use negativeCurrency pipe followed by normal Currency($) pipe. Example: value= -$100.00 , output = ($100.00)
 */

@Pipe({
  name: 'negativeCurrency'
})
@Injectable()
export class NegativeCurrencyPipe implements PipeTransform {

  transform(input: string): string {
    if (!input) { return ''; }
    else {
      return input.charAt(0) === '-' ?
        '(' + input.substring(1, input.length) + ')' :
        input;
    }
  }
}
